export default __webpack_public_path__ + "static/media/doctor_home.d6e2bdb4.jpg";